import React from 'react';
import cn from 'classnames';
import _isFunction from 'lodash/isFunction';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import ModalActionsPortal from './ModalActionsPortal';
import { useModal } from '../context';

/**
 * @param {Object} props
 * @param {import('utils/types').ButtonSize} [props.btnSize]
 * @param {function | null} [props.onConfirm]
 * @param {import('utils/types').ButtonVariant} [props.confirmBtnVariant]
 * @param {string} [props.confirmBtnText]
 * @param {boolean} [props.isCancelDisabled]
 * @param {boolean} [props.isConfirmDisabled]
 * @param {boolean} [props.hideCancelBtn]
 * @param {string} [props.cancelBtnText]
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 */
export default function ModalFooter({
  btnSize = 'md',
  onConfirm = null,
  confirmBtnVariant = 'primary',
  confirmBtnText = 'Confirm',
  isConfirmDisabled = false,
  hideCancelBtn = false,
  cancelBtnText = 'Cancel',
  className = '',
  children = null
}) {
  const { isDisabled, isProcessing, onClose, footerId } = useModal();

  return (
    <div className={cn(styles.container, className)}>
      <UiKit.Flex className="flex-grow-1">{children}</UiKit.Flex>
      <UiKit.Flex id={footerId} align="center" justify="flex-end" gap={8}>
        <If test={!hideCancelBtn}>
          <UiKit.Button
            type="button"
            size={btnSize}
            variant="outline"
            onClick={onClose}
            disabled={isProcessing || isDisabled}
          >
            {cancelBtnText}
          </UiKit.Button>
        </If>
        <If test={_isFunction(onConfirm)}>
          <UiKit.Button
            type="submit"
            size={btnSize}
            variant={confirmBtnVariant}
            onClick={onConfirm}
            disabled={isConfirmDisabled || isDisabled}
            processing={isProcessing}
          >
            {confirmBtnText}
          </UiKit.Button>
        </If>
      </UiKit.Flex>
    </div>
  );
}

export { ModalActionsPortal };
